import { ReactNode, useState } from 'react';

import PrepaidContext from './PrepaidContext';

interface Props {
    children?: ReactNode;
}

function PrepaidProvider({ children }:Props) {
  const [amount, setAmount] = useState<number>(1);
  return (
      <PrepaidContext value={{ amount, setAmount }}>
          {children}
      </PrepaidContext>
  );
}

export default PrepaidProvider;
